import axios from 'axios';
import { getAuthHeader } from '../utils/auth';

export const exportOrders = async (orderIds, selectedFields) => {
  try {
    const response = await axios.post(
      '/api/orders/export/',
      {
        order_ids: orderIds,
        selected_fields: selectedFields
      },
      {
        headers: getAuthHeader(),
        responseType: 'blob'
      }
    );
    
    // Create a download link and trigger it
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'orders_export.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changeOrderCustomer = async (orderIds, customerId) => {
  try {
    const response = await axios.post(
      '/api/orders/change_customer/',
      {
        order_ids: orderIds,
        customer_id: customerId
      },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
